import styled from "styled-components";

export const SpanRed = styled.span`
  color: var(--error-color);
`;

export const H1WithMargin = styled.h1`
  margin-bottom: 1.5rem;
`;
